import type { SVGProps } from 'react'

const SvgTemperatureGroundByDepth = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path d='M4.463 19.538C3.487 18.562 3 17.383 3 16c0-.8.175-1.546.525-2.238.35-.691.842-1.279 1.475-1.762V6c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 8 3c.833 0 1.542.292 2.125.875S11 5.167 11 6v6a5.082 5.082 0 0 1 1.475 1.762c.35.692.525 1.438.525 2.238 0 1.383-.488 2.563-1.463 3.538C10.563 20.512 9.384 21 8 21s-2.562-.488-3.537-1.462M5 16h6c0-.483-.104-.933-.312-1.35A2.908 2.908 0 0 0 9.8 13.6L9 13V6a.968.968 0 0 0-.287-.713A.968.968 0 0 0 8 5a.968.968 0 0 0-.713.287A.968.968 0 0 0 7 6v7l-.8.6c-.383.283-.68.633-.888 1.05A2.977 2.977 0 0 0 5 16' />
    <g opacity={0.5}>
      <path d='M21 15.5h-5V14h5zM21 12h-5v-1.5h5zM21 8.5h-5V7h5zM21 19h-5v-1.5h5zM4.639 3a4.341 4.341 0 0 0-1.033 2H3V3zM8 3c.833 0 1.542.292 2.125.875.334.334.568.71.71 1.125h-5.67c.142-.415.376-.791.71-1.125A2.893 2.893 0 0 1 8 3M21 5h-8.606a4.342 4.342 0 0 0-1.033-2H21z' />
    </g>
  </svg>
)

export default SvgTemperatureGroundByDepth
